import { useEffect, useState } from "react";
import WelcomeCard from "../../components/WelcomeCard";
import { API_ENDPOINTS } from "../../services/apiEndpoints";
import { api1 } from "../../utils/axiosInstance";
import Sidebar from "../../components/Sidebar";
import { Send } from "lucide-react";
import Modal from "../../components/modal/Modal";
import { toast } from "react-toastify";
import SecondaryLoader from "../../components/SecondaryLoader/SecondaryLoader";

const IncompleteUsers = () => {
  const [users, setUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [menteeId, setMenteeId] = useState(null);
  const [emailSubject, setEmailSubject] = useState();
  const [emailMessage, setEmailMessage] = useState();
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await api1.get(API_ENDPOINTS.FETCH_USERS);
      setUsers(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleModalOpen = (id) => {
    setMenteeId(id);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setEmailMessage(null);
    setEmailSubject(null);
    setShowModal(false);
  };

  const handleSendEmail = async () => {
    if (emailMessage && emailSubject) {
      try {
        await api1.post(API_ENDPOINTS.SEND_EMAIL_TO_MENTOR, {
          mentorId: menteeId,
          subject: emailSubject,
          message: emailMessage,
        });
      } catch (error) {
        console.error(error);
      } finally {
        handleModalClose();
      }
    } else {
      toast.error("Please fill the email");
    }
  };

  // only the incomplete profiles
  const incomplete = users.filter((u) => !u.isProfileComplete);

  return (
    <Sidebar>
      <div className="flex flex-col gap-6">
        <WelcomeCard title="Incomplete Profiles" />
        {loading ? (
          <SecondaryLoader />
        ) : (
          <div className="p-6 bg-white min-h-screen">
            <div className="rounded-lg w-full">
              <div className="overflow-x-auto w-full">
                <table className="w-full border-collapse">
                  <thead className="border-t border-b">
                    <tr className="uppercase text-sm">
                      <th className="py-3 px-6 text-left w-1/3">Basic Info</th>
                      <th className="py-3 px-6 text-left w-1/6">Type</th>
                      <th className="py-3 px-6 text-left w-1/6">Status</th>
                      <th className="py-3 px-6 text-center w-1/6">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {incomplete.map((user) => (
                      <tr key={user._id} className="border-b hover:bg-gray-50">
                        {/* Basic Info */}
                        <td className="py-4 px-6">
                          <div className="font-medium">
                            {user.firstName} {user.lastName}
                          </div>
                          <div className="text-sm text-gray-500">
                            {user.email}
                          </div>
                        </td>

                        {/* Type */}
                        <td className="py-4 px-6 capitalize">
                          <span className="inline-block bg-yellow-100 text-yellow-800 text-xs px-2 py-1 rounded">
                            {user.type}
                          </span>
                        </td>

                        {/* Status */}
                        <td className="py-4 px-6">
                          <span className="inline-block bg-red-100 text-red-800 text-xs px-2 py-1 rounded">
                            Incomplete
                          </span>
                        </td>

                        {/* Action */}
                        <td className="py-4 px-6 text-center">
                          <button
                            onClick={() => handleModalOpen(user._id)}
                            className="flex items-center gap-1 bg-[#7E5BEF] hover:opacity-90 text-white text-sm px-4 py-2 rounded"
                          >
                            <Send className="w-4 h-4" />
                            Send Email
                          </button>
                        </td>
                      </tr>
                    ))}

                    {incomplete.length === 0 && (
                      <tr>
                        <td
                          colSpan={4}
                          className="py-4 px-6 text-center text-gray-500"
                        >
                          All profiles are complete
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>

      <Modal
        isOpen={showModal}
        onClose={handleModalClose}
        width="w-[400px] md:w-[600px]"
      >
        <div className="p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Send Email
          </h2>

          <div className="space-y-4">
            <div>
              <label className="text-sm font-medium text-gray-700">
                Subject
              </label>
              <input
                type="text"
                className="w-full border border-gray-300 rounded px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-[#7E5BEF]"
                value={emailSubject}
                onChange={(e) => setEmailSubject(e.target.value)}
                placeholder="Enter email subject"
              />
            </div>
            <div>
              <label className="text-sm font-medium text-gray-700">
                Message
              </label>
              <textarea
                rows={6}
                className="w-full border border-gray-300 rounded px-3 py-2 mt-1 resize-none focus:outline-none focus:ring-2 focus:ring-[#7E5BEF]"
                value={emailMessage}
                onChange={(e) => setEmailMessage(e.target.value)}
                placeholder="Write your message here..."
              />
            </div>

            <div className="flex justify-end gap-3 pt-4">
              <button
                onClick={handleModalClose}
                className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={handleSendEmail}
                className="px-4 py-2 rounded bg-[#7E5BEF] text-white hover:bg-[#674dd0]"
              >
                Send
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </Sidebar>
  );
};

export default IncompleteUsers;
